<template>
  <div class="page1">
    <EForm :formColumns="formColumns" :rowSize="5" :optionsBtn="true" :actionBtn="false" :formData="searchForm"
      ref="form" @onSearch="onSearch" :searchFlag="true" :exportShow="false"></EForm>
    <ETable
      :tableTitle="tableTitle"
      :tableData="tableData"
      :needPagination="true"
      :count="count"
      @changePage="changePage"
      @changeSize="changeSize"
      :page="searchForm.current"
      :page_size="searchForm.size"
    >
      <el-table-column fixed="right" label="操作" width="300px">
        <template slot-scope="scope">
          <div>
            <el-button type="primary" size="mini" @click="draftDownload(scope.row.flowId)">
              下载审核
            </el-button>
            <el-button type="primary" size="mini" @click="draftRescind(scope.row.flowId)">
              撤回
            </el-button>
            <el-button type="primary" size="mini" @click="draftStart(scope.row.flowId)">
              下发签署
            </el-button>
          </div>
        </template>
      </el-table-column>
    </ETable>
    <el-dialog
      title="文件列表"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose">

      <el-table
      :data="urls">
      <el-table-column
        prop="fileName"
        label="文件名称">
      </el-table-column>
      <el-table-column label="下载" width="95px">
        <template slot-scope="scope">
          <div>
            <el-button type="primary" size="mini" @click="download(scope.row.downloadUrl)">
              下载
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <br/>
    <div style="padding-left: 10px;">注：如果无下载文件记录，请先登录签章后台系统完成填写合同任务</div>
    <br/><br/>
    </el-dialog>
  </div>
</template>

<script>
  import ETable from '@/components/ETable';
  import Http from '@/service/http';
  import EDialog from '@/components/EDialog';
  import EButton from '@/components/EButton';
  import EForm from '@/components/EForm';
  import { identity_type, status } from '@/assets/js/config';
  import vxRule from '@/assets/js/formValidate';
  import { otherMixin } from '@/components/mixin';
  import {mapGetters} from 'vuex'
  export default {
    name: 'shopInfo',
    mixins: [otherMixin],
    data() {
      return {
        dialogVisible: false,
        urls: [],
        urlTitle: [
          {
            label: '文件名称',
            prop: 'fileName',
          }
        ],
        tableTitle: [
          {
            label: '流程标题',
            prop: 'signFlowTitle',
          },
          {
            label: '发起时间',
            prop: 'createTime',
          },
          /**
          {
            label: '状态',
            prop: 'signFlowStatus',
          }
          */
        ],
        tableData: [],
        searchForm: {
          contractNo: null,
          flowName: null,
          flowStatus: null,
          current: 1,
          size: 10,
        },
        count: null,
        exportData: {},
        files:[],
        showfiles: false,
        formColumns: [
        {
          title: '流程标题',
          type: 'text',
          property: 'signFlowTitle',
          placeHolder: '请输入',
          show: true,
        }],
      };
    },
    watch: {},
    created() {
      this.getData();

    },
    components: { ETable, EDialog, EButton, EForm },
    computed:{
      ...mapGetters(['buttonList']),
    },
    beforeMount() {},
    methods: {
      async onSearch() {
        this.searchForm.current = 1;
        this.getData();
      },
      async changePage(current) {
        this.searchForm.current = current;
        this.getData();
      },
      changeSize(size) {
        this.searchForm.size = size;
        this.getData();
      },

      async getData() {
        let that = this
        let res = await Http.draftFlowList(this.searchForm);
        if (res.code == 200) {
          that.tableData = res.data.records;
          that.count = res.data.total;
        }
      },
      async draftDownload(flowId) {
        let that = this
        that.dialogVisible = true
        that.urls = []
        let res = await Http.draftDownload({signFlowId: flowId});
        if (res.code === '0') {
          if(res.urls!=null&&res.urls.length>0){
            that.urls = res.urls
          }
        }
      },
      draftRescind(flowId) {
        let that = this
        that.$messageBox.confirm('确定要撤回该任务吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(res => {
          that.draftRescindFun(flowId)
        }).catch(res => {

        });
      },
      async draftRescindFun(flowId) {
        let that = this
        let res = await Http.draftRescind({signFlowId: flowId});
        if (res.code === '0') {
          setTimeout(function () {
            that.getData();
            that.$message.success("操作成功")
          }, 2000);
        }else{
          that.$message.error(res.message)
        }
      },
      download(url){
        window.open(url)
      },
      async draftStart(flowId) {
        let that = this
        that.$messageBox.confirm('下发签署前请先确认填写合同是否已经审核通过。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(res => {
          that.draftStartFun(flowId)
        }).catch(res => {

        });
      },
      async draftStartFun(flowId) {
        let that = this
        let res = await Http.draftStart({signFlowId: flowId});
        if (res.code === '0') {
          setTimeout(function () {
            that.getData();
            that.$message.success("操作成功")
          }, 2000);
          
        }else{
          that.$message.error("请先在签章后台完成填写任务。")
          //that.$message.error(res.message+"请先在签章后台完成填写任务")
        }
      },
      handleCommand(url){
        window.open(url)
      },
      handleClose(done) {
        done();
      }
    }
  };
</script>

<style lang="scss" scoped>
.ws {
  width: 100%;
}
</style>
